import { useNavigate } from "react-router-dom";
import { useSport } from "../../contexts/SportContext";
import { hapticLight } from "../../utils/haptics";

const TABS = [
  { key: "cricket", label: "Cricket", icon: "🏏" },
  { key: "football", label: "Football", icon: "⚽" },
];

export const SportNavigator = () => {
  const { sport, setSport } = useSport();
  const navigate = useNavigate();

  const select = (key) => {
    hapticLight();
    setSport(key);
    navigate("/");
  };

  return (
    <div className="mb-4 flex gap-2 rounded-xl border border-border bg-card p-1" data-testid="sport-navigator">
      {TABS.map((t) => (
        <button
          key={t.key}
          onClick={() => select(t.key)}
          className={`flex min-h-[44px] flex-1 items-center justify-center gap-2 rounded-lg py-2.5 text-sm font-bold transition-colors ${
            sport === t.key
              ? "bg-emerald-500 text-white"
              : "text-foreground/55 hover:text-foreground/80"
          }`}
          data-testid={`sport-tab-${t.key}`}
        >
          <span>{t.icon}</span> {t.label}
        </button>
      ))}
    </div>
  );
};

export default SportNavigator;
